function WaveDivider({ fill, bg, className = "" }) {
  return (
    <div
      className={`wave-divider ${className}`}
      style={bg ? { background: bg } : undefined}
      aria-hidden="true"
    >
      <svg viewBox="0 0 1200 80" preserveAspectRatio="none">
        <path
          fill={fill}
          d="M0,32 C180,80 360,0 600,28 C840,56 1020,8 1200,36 L1200,80 L0,80 Z"
        />
      </svg>
    </div>
  );
}

export default WaveDivider;
